export const FACEBOOK_APP_ID =
  process.env.REACT_APP_FACEBOOK_APP_ID ||
  "YOUR_FACEBOOK_APP_ID not set in .env file";
